import React, {useRef, useEffect, useState, useCallback} from 'react'
import './carousel.scss'
import PropTypes from 'prop-types'
import {Flex} from '@salesforce/retail-react-app/app/components/shared/ui'

const Carousel = ({items = []}) => {
    const containerRef = useRef(null)
    const extendedItems =
        items?.length > 5 ? [...items, ...items, ...items] : items
    const [highlightedIndex, setHighlightedIndex] = useState(null)
    const [isDragging, setIsDragging] = useState(false)
    const [startX, setStartX] = useState(0)
    const [scrollLeft, setScrollLeft] = useState(0)

    const handleMouseDown = (e) => {
        if (!containerRef) return
        setIsDragging(true)
        setStartX(e.pageX - containerRef.current.offsetLeft)
        setScrollLeft(containerRef.current.scrollLeft)
    }

    const handleMouseLeave = () => {
        setIsDragging(false)
    }

    const handleMouseUp = () => {
        setIsDragging(false)
    }

    const handleMouseMove = (e) => {
        if (!isDragging || !containerRef) return
        e.preventDefault()
        const x = e.pageX - containerRef.current.offsetLeft
        const walk = (x - startX) * 1 // Velocidad de desplazamiento
        containerRef.current.scrollLeft = scrollLeft - walk
    }

    useEffect(() => {
        const container = containerRef?.current
        if (!container) return

        container.scrollLeft = container?.scrollWidth / 3

        const handleScroll = () => {
            const center = container.scrollLeft + container.offsetWidth / 2

            const itemEls = Array.from(container.children)
            let closestIndex = -1
            let closestDistance = Infinity

            itemEls.forEach((el, i) => {
                const boxCenter = el.offsetLeft + el.offsetWidth / 2
                const distance = Math.abs(center - boxCenter)
                if (distance < closestDistance) {
                    closestDistance = distance
                    closestIndex = i
                }
            })

            setHighlightedIndex(closestIndex)
        }
        container.addEventListener('scroll', handleScroll)
        handleScroll()

        return () => container.removeEventListener('scroll', handleScroll)
    }, [items])

    const handleSelectedCard = useCallback((ind) => setHighlightedIndex(ind))

    return (
        <Flex
            gap="24px"
            width="100%"
            ref={containerRef}
            alignItems="center"
            justifyContent="center"
            onMouseUp={handleMouseUp}
            className="scroll-wrapper"
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseMove={handleMouseMove}
        >
            {extendedItems?.map((item, i) => (
                <Flex
                    key={i}
                    onClick={() => handleSelectedCard(i)}
                    className={`scroll-item ${
                        i === highlightedIndex ? 'highlighted' : ''
                    }`}
                >
                    {item}
                </Flex>
            ))}
        </Flex>
    )
}

Carousel.propTypes = {
    items: PropTypes.arrayOf(PropTypes.obj)
}

export default Carousel
